import React from 'react'
import Sizecomponent from "../components/Sizecomponent"
import sample from "../assets/sampleimage.png";


const Sizechart = () => {
  return (
    <div>
        <div className="mb-4">
        <img
          src={sample}
          alt="Terms & Conditions Banner"
          className="img-fluid w-100"
        />
      </div>

      <Sizecomponent />
    </div>
  )
}

export default Sizechart